import * as ActionTypes from 'state/actions/types'
import Session from 'shared/utils/session'
import TabSession from 'shared/utils/tabSession'
import { sortByName } from 'shared/utils/array'

export default (state = {
  isFailure: false,
  isRequesting: false,
  isCreating: false,
  active: null
}, action) => {
  switch (action.type) {

    case ActionTypes.INIT_DATA: {
      const {
        activeOrg
      } = action.payload

      if(activeOrg && activeOrg.organisationId) {
        TabSession.setItem('organisationId', activeOrg.organisationId)
      }

      return {
        ...state,
        active: activeOrg
      }
    }

    case `${ActionTypes.PROFILE_REQUEST}_SUCCESS`: {

      const {
        organisations
      } = action.response.payload

      const hasOrganisations = !!organisations?.length
      const organisationId = TabSession.getItem('organisationId') || Session.getItem('lastOrganisationId')

      let activeOrganisation
      if(hasOrganisations && organisationId) {
        activeOrganisation = organisations.find(organisation => organisationId === organisation.organisationId)
      }

      if(hasOrganisations && !activeOrganisation) {
        activeOrganisation = organisations[0]
      }

      if(activeOrganisation && activeOrganisation.organisationId) {
        TabSession.setItem('organisationId', activeOrganisation.organisationId)

        activeOrganisation.projects = activeOrganisation.projects.sort(sortByName)
      }

      return {
        ...state,
        active: activeOrganisation || null,
        isRequesting: false
      }
    }

    case ActionTypes.ACTIVATE_ORGANISATION: {
      const {
        organisation
      } = action.payload

      if(!organisation) {
        console.error('Action ACTIVATE_ORGANISATION missing the organisation', action)
        return { ...state }
      }

      if(organisation && organisation.organisationId) {
        Session.setItem('lastOrganisationId', organisation.organisationId)
        TabSession.setItem('organisationId', organisation.organisationId)
      }

      organisation.projects = organisation.projects.sort(sortByName)

      return {
        ...state,
        active: organisation,
        isCreating: false
      }
    }

    default:
      return state
  }
}
